module.exports = __webpack_public_path__ + "static/media/hospital.eaebb1e8.svg";